import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import JsonExcel from "vue-json-excel";
import VueApexCharts from 'vue-apexcharts'
Vue.use(VueApexCharts)

Vue.config.productionTip = false

Vue.component('v-excel', JsonExcel)

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
